import {useContext, useEffect, useState } from 'react';
import "react-datepicker/dist/react-datepicker.css";
import { ThemeContext } from "../../../../context/ThemeContext";
import { Link} from 'react-router-dom';
import { useGetTutorDashboardQuery } from '../../../../store/services/tutor/DetailsService';
import AverageStarRating from '../../../components/Dashboard/AverageStarRating';
import SessionSection from '../../../components/Dashboard/SessionSection';
import { useSelector } from 'react-redux';

const TutorDashboard = () => {
	const { currentUser } = useSelector((state) => state.auth);
	const [totalCount, setTotalCount] = useState({ upcoming: 0, past: 0 });
	const [pagination, setPagination] = useState({
		upcoming: { page: 1, search: "" }, past: { page: 1, search: "" }});
	const { changeBackground } = useContext(ThemeContext);

	useEffect(() => {
		changeBackground({ value: "light", label: "Light" });
	}, []);

	const { data, error, isLoading, refetch } = useGetTutorDashboardQuery({
	search: pagination.upcoming.search || pagination.past.search, 
	pageNumber: Math.max(pagination.upcoming.page, pagination.past.page)},
		{
			skip: !currentUser?.tutorId && !currentUser?.id, // Skip if no user ID
			refetchOnMountOrArgChange: true, // Always refetch on mount
		}
	);

// Force refetch when component mounts (in case of cached data)
useEffect(() => {
	if (currentUser?.tutorId || currentUser?.id) {
		refetch();
	}
}, [currentUser, refetch]);

	useEffect(() => {
  		if (data?.data?.[0]) {
    		setTotalCount({
      			upcoming: data.data[0].upcomingSessions?.length || 0,
      			past: data.data[0].pastSessions?.length || 0,
    		});
  		}
	}, [data]);
	
	const averageRating = data?.data?.[0]?.averageRating || 0;

  	if (isLoading) return <div className="text-center py-5"><div className="spinner-border" role="status"></div></div>;
  	if (error) return <div className="alert alert-danger">Error loading tutor details.</div>;

	return (
		<>
			 <div className="row align-items-center my-3">
            	<div className="col-lg-6 mb-2">
                	<h2 className="mb-2">Welcome back, {currentUser?.fullName}! 👋</h2>
                	<p className="text-muted">Here’s a snapshot of your progress and upcoming lessons.</p>
            	</div>

            	<div className="col-lg-6 mb--xl-2 mb-4 text-lg-end text-start">
                	<h6 className="heading mb-1">Average Rating</h6>
                 	<div className="mt-2 d-inline-flex align-items-center">
                    	{averageRating > 0 && <AverageStarRating level={averageRating} max={5} />}
                    	<div className="fw-semibold text-muted mt-1">
                        	{averageRating.toFixed(1)}/5
                    	</div>
                	</div>
            	</div>
        	</div>
			
			{/* Upcoming Sessions */}
			<SessionSection title="Upcoming Lessons" data={data?.data?.[0]?.upcomingSessions || []}
				totalCount={totalCount.upcoming} searchPlaceholder="Search upcoming sessions..." 
				searchTerm={pagination.upcoming.search} setSearchTerm={(val) => 
				setPagination(prev => ({...prev, upcoming: {...prev.upcoming, search: val, page: 1}}))} 
				setCurrentPage={(page) => setPagination(prev => ({...prev, upcoming: {...prev.upcoming, page}}))}
				currentPage={pagination.upcoming.page} pageSize={data?.data?.[0]?.pageSize} showStudentName={true} showLanguage={true} showTutor={false} />

      		{/* Availabiliy Section */}
			<div className="card mt-0">
				<div className="card-body d-flex align-items-center justify-content-between flex-wrap">
					<div className="mb-3 mb-md-0">
						<h4 className="mb-2">Set your Availability</h4>
						<p className="text-muted mb-0">Manage your availability here and set your time for you availability.</p>
					</div>
					<Link to="/availability" className="btn btn-primary">
						Manage Availability
					</Link>
				</div>
			</div>

      		{/* Last 7 Sessions */}
			<SessionSection title="Recent Lessons" data={data?.data?.[0]?.pastSessions || []}
				totalCount={totalCount.past} searchPlaceholder="Search here..." 
				searchTerm={pagination.past.search} setSearchTerm={(val) => 
				setPagination(prev => ({...prev, past: {...prev.past, search: val, page: 1}}))} 
				setCurrentPage={(page) => setPagination(prev => ({...prev, past: {...prev.past, page}}))}
				currentPage={pagination.past.page} pageSize={data?.data?.[0]?.pageSize} showStudentName={true} showLanguage={true} showTutor={false} />
		</>
	);
};

export default TutorDashboard;
